<main style="position: relative;">
  <div class="app-pre-loader" *ngIf="areTranslationsLoading">
    <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
  </div>

  <div *ngIf="!areTranslationsLoading" id="backgroundCarousel">
    <div class="cb-slideshow">
      <div blurred-image [small]="backgrounds[0].small" [preview]="backgrounds[0].src"></div>
      <div blurred-image [small]="backgrounds[1].small" [preview]="backgrounds[1].src"></div>
      <div blurred-image [small]="backgrounds[2].small" [preview]="backgrounds[2].src"></div>
      <div blurred-image [small]="backgrounds[3].small" [preview]="backgrounds[3].src"></div>
      <div blurred-image [small]="backgrounds[4].small" [preview]="backgrounds[4].src"></div>
      <div blurred-image [small]="backgrounds[5].small" [preview]="backgrounds[5].src"></div>
    </div>
  </div>

  <div *ngIf="!areTranslationsLoading" id="root" [ngStyle]="{
    'color': getTextColor(),
    'font-family': getFont() + ', sans-serif'
    }">
    <router-outlet></router-outlet>
  </div>
</main>
